import type { ReactNode } from 'react';

interface PlaygroundSectionProps {
  id: string;
  title: string;
  description?: string;
  children: ReactNode;
}

export function PlaygroundSection({ id, title, description, children }: PlaygroundSectionProps) {
  return (
    <section id={id} className="scroll-mt-20 space-y-4 py-8 border-b last:border-0">
      <div className="space-y-1">
        <h2 className="text-2xl font-bold tracking-tight text-primary uppercase">{title}</h2>
        {description && <p className="text-muted-foreground text-sm">{description}</p>}
      </div>
      <div className="pt-4">
        {children}
      </div>
    </section>
  );
}
